'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _is_IS = require('../../date-picker/locale/is_IS');

var _is_IS2 = _interopRequireDefault(_is_IS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _is_IS2['default'];